export default import.meta.ROLLDOWN_FILE_URL_L8nBpPxJiAolfp13rurrxg